import CriteriaCondition from '@/components/query/spec/criteria-condition';
import ConditionOperators from '@/components/query/spec/condition-operators';
import FILTER_TYPES from '@/components/query/filter-types';
import ActiveFilter from '@/components/query/active-filter';
import restoreFiltersFromCriteria from './restore-filters-from-criteria';
import getCriteriaFromActiveFilters from './get-criteria-from-active-filters';

/** @module CriteriaAdapter */

/**
 * Adapter class for Criteria as defined in API back-end.
 * @deprecated
 */
/* eslint-disable class-methods-use-this */
export default class CriteriaAdapter {
    parseQuery({query, filterSet}) {
        const params = {criteria: query, filterSet};
        return restoreFiltersFromCriteria(params);
    }

    getQueryFromActiveFilters(activeFilters) {
        return getCriteriaFromActiveFilters(activeFilters);
    }

    getInitialFilterValue(definition) {
        const map = {
            [FILTER_TYPES.text]: ({condition}) => {
                if (condition.values) {
                    return condition.values;
                }
                return null;
            },
            [FILTER_TYPES.boolean]: ({condition}) => condition.value || false,
            [FILTER_TYPES.numeric]: ({condition}) => {
                const payload = {min: null, max: null};
                if (condition.op === ConditionOperators.between) {
                    payload.min = condition.min;
                    payload.max = condition.max;
                } else if (condition.op === ConditionOperators.gte) {
                    payload.min = condition.value;
                } else if (condition.op === ConditionOperators.lte) {
                    payload.max = condition.value;
                }
                return payload;
            },
        };
        return map[definition.filter.type](definition);
    }


    getFilterPayload({
        index, filter, assign = null, data = null,
    }) {
        let conditionParams = data || {...filter.condition};
        conditionParams = this.normalizeConditionParams({
            type: filter.filter.type,
            params: conditionParams,
        });
        const payload = {
            index,
            data: new CriteriaCondition(conditionParams),
        };
        if (assign) {
            payload.data = {
                ...payload.data,
                ...assign,
            };
        }
        return payload;
    }

    createActiveFilter(filter) {
        return new ActiveFilter({
            filter,
            condition: new CriteriaCondition(),
        });
    }

    normalizeConditionParams({type, params}) {
        const getRangeOperator = () => {
            if (params.min !== null && params.max !== null) {
                return {op: ConditionOperators.between};
            } if (params.min === null) {
                return {op: ConditionOperators.lte, value: params.max};
            }
            return {op: ConditionOperators.gte, value: params.min};
        };
        const map = {
            [FILTER_TYPES.text]: () => ({op: ConditionOperators.in}),
            [FILTER_TYPES.enum]: () => ({op: ConditionOperators.in}),
            [FILTER_TYPES.select]: () => ({op: ConditionOperators.in}),
            [FILTER_TYPES.boolean]: () => ({op: ConditionOperators.equals}),
            [FILTER_TYPES.numeric]: getRangeOperator,
            [FILTER_TYPES.datetime]: getRangeOperator,
        };
        return {
            ...params,
            ...map[type](),
        };
    }
}
